import { sessionState } from './auth/session-state';
import { Component, Renderer2, OnInit } from "@angular/core";
import { AuthService } from "./auth/auth.service";
import { Router, NavigationStart } from "@angular/router";
import * as myGlobalsfunc from '../app/global.function';
import { PrimeNG } from "primeng/config";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: false
})
export class AppComponent implements OnInit {
  public checkSessionRequest;

  constructor(
    private authService: AuthService,
    private renderer: Renderer2,
    private router: Router,
    private primeng: PrimeNG
  ) {
    this.checkSessionRequest = setInterval(() => {
      if (this.authService.isLoggedIn()) {
        const user_id: any = sessionState.getItem("user_id");
        this.authService.isValidUser(user_id).subscribe((data) => {});
      }
    }, 30000);

    this.authService.eventEmitter.subscribe((data) => {
      if (this.checkSessionRequest) {
        clearInterval(this.checkSessionRequest);
      }
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (!this.authService.isLoggedIn()) {
          this.renderer.addClass(document.body, "userNotLoggedIn");
        } else {
          this.renderer.removeClass(document.body, "userNotLoggedIn");
        }
      }
    });
  }

  ngOnInit(): void {
    this.primeng.ripple.set(false);
  }
}
